var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
// FIX: fixed error when import cep-promise
var cep = require("cep-promise");
var initState = {
    countries: [],
    states: [],
    cities: [],
    loading: false,
};
export var LocationContext = React.createContext(initState);
export var LocationProvider = function (_a) {
    var children = _a.children, currentCountryId = _a.currentCountryId, currentStateId = _a.currentStateId, zipCode = _a.zipCode, onSuggestionLoads = _a.onSuggestionLoads, utilRepository = _a.utilRepository;
    var _b = useState(initState), locationState = _b[0], setLocationState = _b[1];
    var updateState = function (property) { return function (data) {
        return setLocationState(function (oldState) {
            var _a;
            return (__assign(__assign({}, oldState), (_a = {}, _a[property] = data, _a)));
        });
    }; };
    useEffect(function () {
        utilRepository.getCountries().then(updateState("countries"));
    }, []);
    useEffect(function () {
        if (!currentCountryId)
            return;
        utilRepository.getStates(currentCountryId).then(updateState("states"));
    }, [currentCountryId]);
    useEffect(function () {
        if (!currentStateId)
            return;
        utilRepository.getCities(currentStateId).then(updateState("cities"));
    }, [currentStateId]);
    useEffect(function () {
        if (!zipCode || zipCode.length < 8)
            return;
        cep(zipCode).then(function (suggestionData) { return __awaiter(void 0, void 0, void 0, function () {
            var state, city, neighborhood, street, suggestedState, cities;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        state = suggestionData.state, city = suggestionData.city, neighborhood = suggestionData.neighborhood, street = suggestionData.street;
                        suggestedState = locationState.states.find(function (_a) {
                            var code = _a.code;
                            return code === state;
                        });
                        if (!suggestedState)
                            return [2 /*return*/];
                        return [4 /*yield*/, utilRepository.getCities(suggestedState === null || suggestedState === void 0 ? void 0 : suggestedState.id)];
                    case 1:
                        cities = _a.sent();
                        updateState("cities")(cities);
                        if (onSuggestionLoads) {
                            onSuggestionLoads({
                                suggestedNeighborhood: neighborhood,
                                suggestedStreet: street,
                                suggestedState: suggestedState,
                                suggestedCity: cities.find(function (_a) {
                                    var description = _a.description;
                                    return description === city;
                                }),
                            });
                        }
                        return [2 /*return*/];
                }
            });
        }); });
    }, [zipCode]);
    return (React.createElement(LocationContext.Provider, { value: locationState }, children));
};
